import type { Quote } from "./testimonials";

export const MOCK_QUOTES: Quote[] = [
  {
    quote:
      "„Die Story rund um die Hagenbergs und deren Freunde ist dicht gespinnt. Eine Intrige folgt der nächsten und keiner der Beteiligten kommt dabei so ganz unbescholten davon. Schatten über Landsitz Hagenberg ist ein top Krimispiel.“",
    source: "spieletest.at",
  },
];
